export const FocusDirective = {
  inserted (el) {
    el.focus()
  }
}
